'use strict';

var nocUtil = require('../../util/noc-util');
var dashboardUtil = require('../../util/dashboard-util');

module.exports = /*@ngInject*/ ["$filter", "$q", "DashboardService", "TripService", "TimeZoneFactory", function ($filter, $q, DashboardService, TripService, TimeZoneFactory) {
    var factory = {};

    /**
     * This function will first fetch the needed data (logins, avgConsumed, vung and sqi's).
     * It then will process these datasets (transform the data for highcharts) and add the axes in the objects
     * @param projectId     the project id
     * @param trainId       the train id
     * @returns {*} promise that contains a Map object
     */
    factory.fetchTrainData = function (projectId, trainId) {
        var deferredArray = [];
        var timezone = TimeZoneFactory.getTzFromCookie();
        deferredArray.push(DashboardService.getTrainLogins(projectId, trainId, timezone).$promise);
        deferredArray.push(DashboardService.getTrainAvgConsumed(projectId, trainId, timezone).$promise);
        deferredArray.push(DashboardService.getTrainVung(projectId, trainId, timezone).$promise);
        deferredArray.push(DashboardService.getTrainSqis(projectId, trainId, timezone).$promise);

        return $q.all(deferredArray).then(function (data) {
            var map = new Map();
            map.set("logins", TimeZoneFactory.addTimeZoneToTimestamp(data[0]));
            map.set("avgConsumed", TimeZoneFactory.addTimeZoneToTimestamp(data[1]));
            map.set("vung", TimeZoneFactory.addTimeZoneToTimestamp(data[2]));
            map.set("sla", TimeZoneFactory.addTimeZoneToTimestamp(data[3]));
            return map;
        });
    };

    factory.getTrainSynchronizationState = function (projectId, trainId, callback) {

        DashboardService.getTrainContent(projectId, trainId, function (data) {
            dashboardUtil.parseSynchronizationState(data, function (content) {
                callback(content);
            });
        });
    };

    factory.getTrainConsumption = function (projectId, trainId, callback) {
        var timezone = TimeZoneFactory.getTzFromCookie();
        DashboardService.getTrainConsumption(projectId, trainId, timezone, function (data) {
            callback(data);
        });
    };

    factory.getTripSqisInPeriod = function (projectId, trainId, sqiToDivLinker) {
        var period = nocUtil.beginAndEndOfDate(new Date());

        period = TimeZoneFactory.formatPeriodInCurrentTimezone(period.from, period.to);

        TripService.getTrainSqis({
            'projectId': projectId,
            'trainId': trainId,
            'from': period.start,
            'to': period.end
        }, function (data) {
            data.forEach(function (sqi) {
                createSqiGauge(sqi, sqiToDivLinker);
            })
        });
    };

    return factory;
}];
